import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flag, Pencil } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Overline, Loading } from "@/components/shared";

export default function Conclusion() {
  const [data, setData] = useState(null);
  const { user } = useAuth();
  useEffect(() => { api.get("/conclusion").then((r) => setData(r.data)); }, []);
  if (!data) return <Loading />;

  return (
    <div className="max-w-6xl" data-testid="conclusion-page">
      <div className="flex items-start justify-between gap-4">
        <Overline className="text-nm-coral">Conclusion</Overline>
        {user?.is_admin && (
          <Link to="/app/admin/page/conclusion" data-testid="admin-edit-conclusion"
            className="inline-flex items-center gap-1.5 rounded-full border border-nm-primary/20 px-3.5 py-1.5 text-xs font-medium text-nm-primary hover:bg-nm-primary/5 transition-colors">
            <Pencil size={13} /> Edit page
          </Link>
        )}
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl text-nm-ink mt-2 leading-tight" data-testid="conclusion-title">{data.title}</h1>
      <p className="text-xl text-nm-neutral font-light leading-relaxed mt-5" data-testid="conclusion-intro">{data.intro}</p>

      <div className="mt-10 space-y-5" data-testid="conclusion-body">
        {(data.body || []).map((b, i) => {
          switch (b.t) {
            case "h2":
              return (
                <h2 key={i} className="font-serif text-3xl font-semibold text-nm-ink mt-14 pt-7 border-t border-white leading-snug flex items-center gap-3">
                  <span className="h-7 w-1.5 rounded-full bg-nm-coral shrink-0" />
                  {b.text}
                </h2>
              );
            case "h3":
              return <h3 key={i} className="font-serif text-xl font-semibold text-nm-coral mt-9 leading-snug">{b.text}</h3>;
            case "ul":
              return (
                <ul key={i} className="space-y-2.5 pl-1">
                  {b.items.map((it, k) => (
                    <li key={k} className="flex items-start gap-3 text-nm-ink/85 leading-relaxed">
                      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-nm-primary shrink-0" />{it}
                    </li>
                  ))}
                </ul>
              );
            default:
              return <p key={i} className="text-nm-ink/85 leading-relaxed text-[17px]">{b.text}</p>;
          }
        })}
      </div>

      <div className="mt-14 flex items-center gap-3 rounded-3xl border border-nm-coral/30 bg-nm-coral/5 px-7 py-6" data-testid="conclusion-footer">
        <Flag size={20} className="text-nm-coral shrink-0" />
        <p className="text-nm-ink font-medium">You do not need to become the perfect manager. You need to keep becoming a better one.</p>
      </div>
    </div>
  );
}
